export default function CentreUserApi({ makeRequest, buildRequest, baseUrl = '' }) {
    
    function getUserCentres() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/centreUser`));
        });
    }
   
    return {
        getUserCentres
    }

}